const namespaced = true;
const state = {
  userAccountInformation: {},
  signedIn: false
};
const mutations = {
  setAccountInfo(state, data) {
    state.userAccountInformation = data;
  },
  setSignedIn(state, data) {
    state.signedIn = data;
  },
  setUserId(state, payload) {
    state.identityId = payload;
  }
};
const actions = {
  callSetAccountInfo({ commit }, payload) {
    commit("setAccountInfo", payload);
  },
  callSetSignedIn({ commit }, payload) {
    commit("setSignedIn", payload);
  }
};

export default {
  namespaced,
  state,
  mutations,
  actions
};
